// Supporter name colors in Study Hall (docs/SUPPORTERS.md 8). Index = the server's name_color.
// One shade for dark looks and one for light looks; public/styles/hall.css carries the same values
// and test/contrast.test.mjs checks both at 4.5:1 on every look. None is the staff color.
export const NAME_COLORS = [
	{ label: "Teal", dark: "#5eead4", light: "#0f6b63" },
	{ label: "Violet", dark: "#c4b5fd", light: "#6d28d9" },
	{ label: "Rose", dark: "#fda4af", light: "#b4123a" },
	{ label: "Amber", dark: "#fcd34d", light: "#8a3c0c" },
	{ label: "Sky", dark: "#7dd3fc", light: "#035f91" },
	{ label: "Lime", dark: "#bef264", light: "#3b5c11" },
	{ label: "Coral", dark: "#fdba74", light: "#b03a0b" },
	{ label: "Orchid", dark: "#f0abfc", light: "#951a9f" },
];
export const FLAIRS = { star: "Star", book: "Book", leaf: "Leaf", moon: "Moon", note: "Music note", spark: "Spark", pencil: "Pencil", flask: "Flask" };
export const BADGE_NAMES = { supporter: "Supporter", patron: "Patron", founding: "Founding supporter" };
